import React  from 'react';
// import los hooks que voy a usar de react
import {useState, useEffect} from 'react';
// importo los hooks de react redux
import {useDispatch, useSelector} from 'react-redux'
import { getDogs,orderByName, filterApiCreated, orderByWeight,getTemperaments,orderByTemp} from '../acctions'; 
import Card from "./Card";
import { Link } from "react-router-dom";
import Paginado from './Paginado'; 
import SearchBar from './SearchBar';
import s from '../css/home.module.css'
import loading from '../image/loadingcan.gif'
import perritos from '../image/perritos.png'


export default function Home(){

    let dispatch = useDispatch()
    let allDogs = useSelector ((state) => state.dogs)
    //la linea anterior es lo mismo que el map state to props, es decir
    //me trae en allCharacters todo lo que esta en el estado de characters
    //asi ya no nos traemos las props.
    const [orden, setOrden]=useState('')
//INICIA PAGINADO 
    
    // Pagina actual, que me setee pagina actual
    const [currentPage,setCurrentPage]= useState(1)  //seteo en 1
        // personajes por pagina,linea siguiente quite el  setCharactersPerPage, funciona igual 
    const [dogsPerPage, setDogsPerPage] = useState(8)//setea 6 por pagina
    //   indice ultimo personaje , pag. act  * cantidad de personas
    const indexOfLastDogs = currentPage * dogsPerPage // 0 a 5 que son 6
    const indexOfFirstDogs = indexOfLastDogs - dogsPerPage //0
    const currentDogs = allDogs.slice(indexOfFirstDogs,indexOfLastDogs)

    const paginado = (pageNumber)=>{
        setCurrentPage(pageNumber)
    }   

    //la otra parte en el archivo paginado.jsx en components

const temperaments = useSelector((state)=> state.temperaments)
// TERMINA PAGINADO

    useEffect(()=> {
        dispatch(getDogs());// traemos a getcharacters
       
    },[dispatch])// el , [] es para que no se me haga un loop infinito de llamados.
    
    useEffect(()=> {
      
        dispatch(getTemperaments());
    },[dispatch])// el , [] es para que no se me haga un loop infinito de llamados.
    
    function handleClick(e){
        e.preventDefault();
        dispatch(getDogs());
    }
    
    function handleSort_2(e){
        /* e.preventDefault(); */
        dispatch(orderByWeight(e.target.value))
        setCurrentPage(1); 
        setOrden(`Ordenado ${e.target.value}` )  
    }  
    function handleSort(e){
        /* e.preventDefault(); */
        dispatch(orderByName(e.target.value))
        setCurrentPage(1); 
        setOrden(`Ordenado ${e.target.value}` )  
    }  
    function handleFilterApiyCreated(e){
        dispatch(filterApiCreated(e.target.value));
        setCurrentPage(1);
    }

    function handleSelect(e){
        e.preventDefault();
        dispatch(orderByTemp(e.target.value));
        setCurrentPage(1);
    }

    return (
        <div className={s.superconten}>
            <img className={s.perritos} src={perritos} />
            <img className={s.perritos2} src={perritos} />
            <Link to ='/aboutme'><p className={s.about}>About Me</p></Link>
            <div> <h2>FIND YOUR FAVORITE BREED</h2  ></div>
            <div className={s.btn0}>
              <Link  to = '/dogcreate'><button className={s.btn1}>Create breed</button></Link>
              <SearchBar/>
              <button className={s.btn1} onClick = {e=> {handleClick(e)}}>
                    Refresh
                </button> 
            </div>

            {/* //filtros */}
            <div className={s.conte2}>  
                
                <select className={s.select} onChange={handleSort_2}>
                    <option value="wmin">weight Max</option>
                    <option value="wmax">weight Min</option>
                </select>    
                <select className={s.select}  onChange={e=> handleFilterApiyCreated(e)}>
                    <option value='All'>All</option>
                    <option value='created'>Creados</option>
                    <option value='api'>Api</option>
                </select>
                <select className={s.select} onChange={handleSort}>
                    <option value = 'asc' > A - Z </option>
                    <option value = 'desc'> Z - A </option>
                </select>
                 {/*    //Filtro por temperamentos  */}
                <select className={s.select} onChange={e => handleSelect(e)}>
                       <option value="All">All</option>
                     {temperaments.map((temp)=>(
                        <option key={temp.id} value={temp.name}>{temp.name}</option>
                        ))
                     }                       
                </select>  

            </div>
            <div>
                <Paginado
                    dogsPerPage= {dogsPerPage}
                    allDogs = {allDogs.length}
                    paginado = {paginado}
                />    
            </div> 
            <div className={s.cardh}>

                
                {
                    currentDogs.length>0?
                    currentDogs.map((el)=>{
                    return (                                
                    <div >                      
                        <Link to={"/home/" + el.id}> 
                            <Card name={el.name} weight_Min={el.weight_Min} weight_Max={el.weight_Max}
                            image={el.image} key={el.id} 
                            temperaments={el.temperaments}/>
                        </Link>
                    </div>  
                           );})
                           : <img  className={loading} src={loading} alt="img not found" />       
                }
            </div>    
        </div> 
    )}

                    